// extracted by mini-css-extract-plugin
export default {"root":"IconEye_root__x9Q+-"};